export default __webpack_public_path__ + "static/media/BieniMedicoLogoLarge.5e652f7f.svg";